/**
 * Compatibility exports for authorization-aware shell and administration code.
 * The generated backend vocabulary remains the single source of truth.
 */
import {
  PERMISSION_CODES,
  PERMISSION_CODE_SET,
  type PermissionCode,
} from "../generated/shell-permission-codes";

export const permissionCodes = PERMISSION_CODES;
export const permissionCodeSet: ReadonlySet<string> = PERMISSION_CODE_SET;
export type ShellPermissionCode = PermissionCode;
